import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const getPricingTitleInternal = () => {
    const checkGate = checkFeatureFlagGate(
        featureFlags.jiraProductDiscoveryPremiumWacUpdates
    );
    return checkGate
        ? "Jira Product Discovery Pricing Page (GWP-5783)"
        : "Jira Product Discovery Pricing Page";
};
